module.exports = __webpack_public_path__ + "static/media/forecast-financial.3bf53c5b.png";